const getParentMessageIds = (messages) => {
  return messages.filter((msg) => msg.parentMessageId).map((msg) => msg.parentMessageId);
};

const getPreparedMessageData = (messages) => {
  const parentMessageIds = getParentMessageIds(messages);
  return messages
    .reduce((filteredMessages, element) => {
      if (!element.message || parentMessageIds.includes(element.messageId)) {
        return filteredMessages;
      }
      let parentMessage = {};
      if (element.parentMessageId) {
        parentMessageIds.push(element.parentMessageId);
        parentMessage = messages.find((msg) => msg.messageId === element.parentMessageId) ?? {};
      }
      return [...filteredMessages, { ...element, type: 'text', parentMessage }];
    }, [])
    .sort((a, b) => new Date(a.messageDateTs) - new Date(b.messageDateTs));
};

export { getPreparedMessageData };
